import { formatMetric } from '@sparkai/metric-utils'

import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type ProgramPerformanceAccuracyProps = BaseNotificationItemProps & {
  name: string
  attribute: string
  accuracy: number
  type: 'program-performance-accuracy'
}

export function ProgramPerformanceAccuracy({
  name,
  attribute,
  accuracy,
  ...props
}: ProgramPerformanceAccuracyProps) {
  return (
    <NotificationItem
      {...props}
      title={`${name} ${attribute} Drop`}
      descriptionAddon={
        <div className='flex text-sm text-gray-500'>
          <p>Current accuracy:&nbsp;</p>
          <b>{formatMetric(accuracy * 100, 'percent')}</b>
        </div>
      }
    />
  )
}
